<app-requests></app-requests>
<span *ngIf="isListloading==false">
  <app-refresh (click)="getRequests()" [buttonDisplay]="true"></app-refresh>
</span>
<span *ngIf="isListloading==true">
  <app-refresh [buttonDisplay]="false"></app-refresh>
</span>
<app-error *ngIf="isError" [message]="errorMessage"></app-error>
<div class="container-fluid font-color-navy container-shadow">
  <span *ngIf="isListloading" class="justify-content-center">
    <app-loading [displayeMessage]="true"></app-loading>
  </span>
  <table class="table-new-design" *ngIf="!isEmptyList">
    <thead>
      <tr class="group myTasks-request-title font-color-white bold-text">
        <th>Id</th>
        <th>Type</th>
        <th>Title</th>
        <th>Status</th>
        <th>Deadline</th>
        <th>Requestor</th>
        <th>Link</th>
      </tr>
    </thead>
    <tbody *ngFor="let request of requests" title="Click on the button to load request details">
      <tr>
        <td><button class="btn-new-ui-xs" (click)="onRequestNaviagte(request.id)">{{request.id}} </button><span title="Load Request detail in new tab" style="margin-bottom: 30px;"><svg height="19.96" width="20" style="cursor: pointer;float:right" (click)="onRequestNaviagteNewPage(request.id)" viewBox="0 0 20 20" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" fill="#000000"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <title>icon/20/icon-open-in-new</title> <desc>Created with Sketch.</desc> <defs> </defs> <g id="Output-svg" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"> <g id="out" transform="translate(-838.000000, -29.000000)" fill="#EE7D11"> <path d="M855,46 L841,46 L841,32 L848,32 L848,30 L841,30 C839.89,30 839,30.9 839,32 L839,46 C839,47.1 839.89,48 841,48 L855,48 C856.1,48 857,47.1 857,46 L857,39 L855,39 L855,46 L855,46 Z M850,30 L850,32 L853.59,32 L843.76,41.83 L845.17,43.24 L855,33.41 L855,37 L857,37 L857,30 L850,30 L850,30 Z" id="path"> </path> </g> </g> </g></svg></span></td>
        <td>{{request.requestType}}</td>
        <td style="cursor:pointer" (click)="onRequestNaviagte(request.id)">{{request.title}}</td>
        <td>{{request.status}}</td>
        <td>{{request.deadline | date:'medium'}}</td>
        <td>{{request.requestor}}</td>
        <td><span class="btn context-menu" title="View Task Response Details"><a href="{{request.externalLink}}" target="_blank" style="cursor:pointer;"><svg xmlns="http://www.w3.org/2000/svg" width="20" height="19.96" viewBox="0 0 20 19.96"><g id="View-in-Azure-icon" transform="translate(0 -2862)">                                        <path id="azure_devops_logo_icon_145466" d="M0,11.156,1.872,8.686l7-2.848V3.78l6.142,4.493L2.471,10.707v6.856L0,16.85ZM20,7.448v12.21L15.2,23.74,7.454,21.194V23.74L2.471,17.562l12.549,1.5V8.272Z" transform="translate(0 2858.22)" fill="#ee7d11" /></g></svg></a></span></td>
      </tr>
    </tbody>
  </table>
  <h2 class="bold-text" *ngIf="isEmptyList">There are no items to show.</h2>
</div>
<br />
<mat-paginator [length]="totalRecords"
               [pageSize]="10"
               [pageSizeOptions]="[10, 20, 50, 100]"
               aria-label="Select page">
</mat-paginator>

